var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"skeleton-wrap"},[(_vm.variant == 'text')?_c('div',{staticClass:"skeleton",class:_vm.classes,style:({ width: this.getRandomInt(20, 100) + '%'})}):_c('div',{staticClass:"skeleton",class:_vm.classes})])}
var staticRenderFns = []

export { render, staticRenderFns }